export default __webpack_public_path__ + "static/media/hands.fd53ac0f.png";